// extracted by mini-css-extract-plugin
var _1 = "bpl__leaderboard-pagination__qVC9G";
var _2 = "bpl__leaderboard-pagination__button__nyJ9n";
var _3 = "bpl__leaderboard-pagination__button__m-current__gcrQ4";
var _4 = "bpl__leaderboard-pagination__ellipsis__JDVd0";
export { _1 as "leaderboard-pagination", _2 as "leaderboard-pagination__button", _3 as "leaderboard-pagination__button__m-current", _4 as "leaderboard-pagination__ellipsis" }
